module.exports = __webpack_public_path__ + "img/video-iconsvg.020ba11e.svg";